var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.cardData)?_c('user-social-card',_vm._b({},'user-social-card',_vm.cardData,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }